import { defineComponent as _defineComponent } from 'vue'
import { useListeners } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'StateChip',
  props: {
    value: null
  },
  emits: ["closeEvent"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'closeEvent'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: string;
};




const listeners = useListeners();
const hasCloseEvent = !!listeners.closeEvent;

return { __sfc: true,props, emits, listeners, hasCloseEvent }
}

})